
import React from "react";
import { Modal } from "./Modal";

type Props = {
  isOpen: boolean;
  title?: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDeleteModal({ isOpen, title = "確認刪除", message = "確定要刪除此筆資料嗎？此操作無法復原。", onConfirm, onCancel }: Props) {
  if (!isOpen) return null;
  return (
    <Modal title={title} onClose={onCancel} width={400}>
      <div style={{ padding: "10px 0" }}>
        <p className="p" style={{ fontSize: 15, color: "var(--text)" }}>{message}</p>
      </div>
      <div className="row" style={{ marginTop: 20, justifyContent: "flex-end", gap: 10 }}>
        <button className="btn" style={{ width: "auto", background: "transparent", border: "1px solid #555", color: "#ddd" }} onClick={onCancel}>
          取消
        </button>
        <button className="btn" style={{ width: "auto", background: "var(--danger)", color: "#fff", border: "none" }} onClick={onConfirm}>
          確認刪除
        </button>
      </div>
    </Modal>
  );
}
